import { IStrings } from 'localization/IStrings';
import { TimeScale } from './TimeScale';

export const createTimeScaleRecord = (strings: IStrings): Record<TimeScale, string> => {
	return {
		'15': `15 ${strings.minutes}`,
		'30': `30 ${strings.minutes}`,
		'60': `1 ${strings.hour}`,
		'120': `2 ${strings.hours}`,
	};
};
